import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import TheEdit from "./components/TheEdit";
import OurStory from "./components/OurStory";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import WhatsAppWidget from "./components/WhatsAppWidget";

const Landing = () => (
  <div className="App">
    <Header />
    <main>
      <Hero />
      <Marquee />
      <TheEdit />
      <OurStory />
      <Features />
      <Testimonials />
    </main>
    <Footer />
    <WhatsAppWidget />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
